import { Action } from 'redux';
import { put, select } from '@redux-saga/core/effects';

import { ACTION_CREATOR_NAME, channelHelper, errorToBasketErrorModel, generateExternalUrlByPath, paymentHelper } from 'helpers';
import { ErrorAction, AppState } from '../../root.types';
import { PaymentSessionModel } from 'models/Payment';
import { api } from 'repositories/api';
import { BasketSagaReturnType } from 'store/sagaHelpers';
import { PaymentActionTypes, PaymentActions } from '../payment.types';
import { routes } from 'routes';


export interface CreatePaymentSessionAction extends Action<PaymentActionTypes.CREATE_PAYMENT_SESSION> {
}

export interface CreatePaymentSessionActionStart extends Action<PaymentActionTypes.CREATE_PAYMENT_SESSION_START> {
}

export interface CreatePaymentSessionActionSuccess extends Action<PaymentActionTypes.CREATE_PAYMENT_SESSION_SUCCESS> {
    paymentSession: PaymentSessionModel;
}

export interface CreatePaymentSessionActionError extends ErrorAction<PaymentActionTypes.CREATE_PAYMENT_SESSION_ERROR> {
}

export const createPaymentSession: () => CreatePaymentSessionAction = () => ({
    type: PaymentActionTypes.CREATE_PAYMENT_SESSION
});
createPaymentSession[ACTION_CREATOR_NAME] = 'createPaymentSession';

export type CreatePaymentSessionFunc = (...args: Parameters<typeof createPaymentSession>) => void;

export function* createPaymentSessionSaga(): BasketSagaReturnType {
    yield put<PaymentActions>({
        type: PaymentActionTypes.CREATE_PAYMENT_SESSION_START
    });

    try {
        let state: AppState = yield select();

        const deliveryDetails = state.checkoutState.deliveryDetails!;
        const basket = state.basketState.basket!;
        const amount = paymentHelper.getDeposit(state.paymentState.paymentDetails);

        const paymentSession = yield api.payment.createPaymentSession(
            basket.code,
            amount,
            basket.session.userId,
            basket.deliveryAddress!.email!,
            deliveryDetails,
            channelHelper.getChannel(),
            generateExternalUrlByPath(routes.payment.path));

        yield put<PaymentActions>({
            type: PaymentActionTypes.CREATE_PAYMENT_SESSION_SUCCESS,
            paymentSession
        });

        return true;
    } catch (error) {
        yield put<PaymentActions>({
            type: PaymentActionTypes.CREATE_PAYMENT_SESSION_ERROR,
            error: errorToBasketErrorModel(error, 'createPaymentSessionSaga')
        });

        return false;
    }
}